export default __webpack_public_path__ + "static/media/hoodie.fb3b47c6.jpg";